module.exports = __webpack_public_path__ + "static/media/delete-icon.628e8395.svg";